import React from 'react';
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { Title } from 'react-admin';
import MenuImage from '../../extensions/neo/menu/Menu.png';

/**
 * Menu Management Placeholder Page
 * 
 * This component displays a placeholder image showing the planned
 * menu management interface design.
 */
export const MenuManagementPlaceholder = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Title title="Menu Management" />
      
      <Card>
        <CardHeader 
          title="Menu Management" 
          subheader="Coming Soon - Menu Management Interface"
        />
        <CardContent>
          <Typography variant="body1" gutterBottom>
            This is a placeholder for the Menu Management module. Below is the design mockup:
          </Typography>
          
          <Box 
            sx={{ 
              marginTop: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              padding: 2,
              borderRadius: 1,
              overflow: 'auto'
            }}
          >
            <img 
              src={MenuImage} 
              alt="Menu Management Design Mockup" 
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }} 
            />
          </Box>
          
          <Typography 
            variant="caption" 
            display="block" 
            sx={{ marginTop: 2, textAlign: 'center', color: 'text.secondary' }}
          >
            Design mockup for the upcoming Menu Management interface
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MenuManagementPlaceholder;

